import { connect } from 'formik'
import { cloneDeep } from 'lodash'
import { IntlShape, useIntl } from 'react-intl'
import styled from 'styled-components'
import { string } from 'yup'

import Label from '@/components/Label'
import { FormLabel, Row } from '@/components/StyledComponents'
import { VariableInputContainer } from '@/pages/SpaceAppBuilder/components/StyledComponents'
import VariableInput from '@/pages/SpaceAppBuilder/components/VariableInput/VariableInput'
import { useWorkflowFeature } from '@/pages/SpaceAppBuilder/FeaturesPage/WorkflowFeatureContext'
import convertJSONtoSchema from '@/pages/SpaceAppBuilder/utilities/convertJSONToSchema'
import { FieldTypes, StepData, TextToEmbeddingsStepData } from '@/pages/SpaceAppBuilder/utilities/interfaces'

import messages from './messages'

const StyledRow = styled(Row)`
  justify-content: flex-start;
  margin-bottom: 5px;
`

type TextToEmbeddingsProps = {
  readOnly?: boolean
}

const getValidationSchema = (intl: IntlShape) => {
  return {
    text: string().required(intl.formatMessage(messages.textRequired))
  }
}

const getInitialValues = (stepData: TextToEmbeddingsStepData): StepData => {
  return {
    text: stepData.text ?? ''
  }
}

const getNetworkRequestObject = (data: { triggerData: any; stepData: any }) => {
  const updatedValues: any = cloneDeep(data)
  const outputJson = {
    records: [
      {
        uuid: '',
        originalText: '',
        embeddings: [0.1],
        documentRefUrl: ''
      }
    ]
  }

  // used to define variables for the step
  updatedValues.output = convertJSONtoSchema(outputJson)

  return updatedValues
}

const TextToEmbeddingsOperation = ({ readOnly = false }: TextToEmbeddingsProps) => {
  const intl = useIntl()

  const { getVariablesForStep } = useWorkflowFeature()
  const variables = getVariablesForStep()
  return variables?.length > 0 ? (
    <>
      <Label className="mt-4" required>
        {intl.formatMessage(messages.textChunks)}
      </Label>
      <VariableInputContainer>
        <VariableInput
          name={'stepData.text'}
          multiline={true}
          placeholder={intl.formatMessage(messages.enterTextChunks)}
          variables={variables}
          validVariableTypes={[FieldTypes.ARRAY, FieldTypes.STRING, FieldTypes.ANY]}
          readOnly={readOnly}
        />
      </VariableInputContainer>
    </>
  ) : (
    <StyledRow>
      <FormLabel>{intl.formatMessage(messages.arrayVariableErrorMessage)}</FormLabel>
    </StyledRow>
  )
}

export default connect(TextToEmbeddingsOperation)

export { getInitialValues, getValidationSchema, getNetworkRequestObject }
